// extracted by mini-css-extract-plugin
export default {"spinner":"Loader_spinner__t9xg3","logo":"Loader_logo__ZAHit","para":"Loader_para__q79ih"};